import type { RouteMeta } from 'vue-router'
import { i18n } from '@/plugins/vueI18n'

export const getRouteTitle = (meta?: RouteMeta): string => {
  const title = (meta?.title as string) || ''
  const titleKey = meta?.titleKey as string | undefined
  const global = i18n?.global as any

  if (titleKey && global?.te(titleKey)) {
    return global.t(titleKey)
  }

  return title
}
